import { IndicatorType } from '@risksmart-app/domain/src/types/consts/indicator-type';

/**
 * Whether the read-only Bands tab (CUS-187) should be registered at all for
 * an indicator — the `configurable_thresholds` flag must be on AND the
 * indicator must be numeric. Both signals are checked here (rather than
 * inside the tab component) so `useTabs` can omit the tab entirely — flag
 * off or a text/boolean indicator renders the page exactly as it does today,
 * with no "Bands" entry in the tab strip.
 */
export const shouldShowBandsTab = (
  isConfigurableThresholdsEnabled: boolean,
  indicatorType: IndicatorType | null | undefined
): boolean =>
  isConfigurableThresholdsEnabled && indicatorType === IndicatorType.Number;
